export default __webpack_public_path__ + "static/media/63532__florian-reinke__click2-rev.371ee085.mp3";